export default __webpack_public_path__ + "static/media/black-mesh-wwg-hat.c4051dda.png";